package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings
import kotlinx.serialization.builtins.MapSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.json.Json

private const val KEY_UNLOCKED = "achievements_unlocked"
private const val KEY_SEEDED = "achievements_seeded"
private const val KEY_BRAINSTORM_ROUNDS = "achievements_brainstorm_rounds"
private const val KEY_UNSEEN = "achievements_unseen"

private val unlockedSerializer = MapSerializer(String.serializer(), Long.serializer())

class SettingsAchievementStore(
    private val settings: Settings,
) : AchievementStore {
    override fun unlocked(): Map<String, Long> {
        val raw = settings.getStringOrNull(KEY_UNLOCKED) ?: return emptyMap()
        return runCatching { Json.decodeFromString(unlockedSerializer, raw) }.getOrDefault(emptyMap())
    }

    override fun saveUnlocked(unlocked: Map<String, Long>) {
        settings.putString(KEY_UNLOCKED, Json.encodeToString(unlockedSerializer, unlocked))
    }

    override fun isSeeded(): Boolean = settings.getBoolean(KEY_SEEDED, false)

    override fun markSeeded() {
        settings.putBoolean(KEY_SEEDED, true)
    }

    override fun brainstormRounds(): Int = settings.getInt(KEY_BRAINSTORM_ROUNDS, 0)

    override fun incrementBrainstormRounds(): Int {
        val next = brainstormRounds() + 1
        settings.putInt(KEY_BRAINSTORM_ROUNDS, next)
        return next
    }

    override fun unseen(): Set<String> =
        settings.getString(KEY_UNSEEN, "").split(',').filter { it.isNotBlank() }.toSet()

    override fun saveUnseen(ids: Set<String>) {
        settings.putString(KEY_UNSEEN, ids.joinToString(","))
    }

    override fun resetAll() {
        settings.remove(KEY_UNLOCKED)
        settings.remove(KEY_SEEDED)
        settings.remove(KEY_BRAINSTORM_ROUNDS)
        settings.remove(KEY_UNSEEN)
    }
}
